/* ==========================================================================
   ATN Homepage V1.0 — Section 05: Global Opportunity Banner
   Spec reference: 05_Section.docx §36

   Analytics only. Fires events for the two CTAs. Hover is CSS-only.
   ========================================================================== */

(function () {
  'use strict';

  function deviceType() {
    var w = window.innerWidth;
    if (w <= 749) return 'mobile';
    if (w <= 1100) return 'tablet';
    return 'desktop';
  }

  function sectionIdFrom(el) {
    var wrapper = el.closest('[id^="shopify-section-"]');
    return wrapper ? wrapper.id.replace('shopify-section-', '') : '';
  }

  function send(root, eventName, params) {
    if (root.dataset.analytics !== 'true' || !eventName) return;

    var payload = Object.assign(
      {
        device_type: deviceType(),
        section_id: sectionIdFrom(root),
        current_page: window.location.pathname
      },
      params || {}
    );

    if (Array.isArray(window.dataLayer)) {
      window.dataLayer.push(Object.assign({ event: eventName }, payload));
    }
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, payload);
    }
  }

  function bindAnalytics(root) {
    if (root.dataset.analytics !== 'true') return;

    root.addEventListener('click', function (event) {
      var cta = event.target.closest('[data-atn-go-event]');
      if (!cta) return;

      send(root, cta.dataset.atnGoEvent, {
        cta_label: (cta.textContent || '').trim(),
        destination_url: cta.getAttribute('href') || ''
      });
    });
  }

  /* ---- Mobile slider --------------------------------------------------- */

  function bindSlider(root) {
    if (root.dataset.mobileSlider !== 'true') return;

    var grid = root.querySelector('[data-atn-go-grid]');
    var nav = root.querySelector('[data-atn-go-slider-nav]');
    var prevBtn = root.querySelector('[data-atn-go-slider-prev]');
    var nextBtn = root.querySelector('[data-atn-go-slider-next]');
    if (!grid || !nav || !prevBtn || !nextBtn) return;

    var loop = root.dataset.sliderLoop === 'true';
    var mql = window.matchMedia('(max-width: 749px)');

    function items() {
      return Array.prototype.slice.call(grid.querySelectorAll('.atn-go__benefit'));
    }

    function perView() {
      var v = parseInt(
        getComputedStyle(root).getPropertyValue('--atn-go-slider-per-view'),
        10
      );
      return v > 0 ? v : 2;
    }

    function currentIndex() {
      var list = items();
      var scrollLeft = grid.scrollLeft;
      var closest = 0;
      var min = Infinity;
      list.forEach(function (item, i) {
        var diff = Math.abs(item.offsetLeft - scrollLeft);
        if (diff < min) {
          min = diff;
          closest = i;
        }
      });
      return closest;
    }

    function goTo(index) {
      var list = items();
      if (!list.length) return;
      var step = perView();

      if (index < 0) index = loop ? Math.max(0, list.length - step) : 0;
      if (index > list.length - 1) index = loop ? 0 : list.length - 1;

      grid.scrollTo({ left: list[index].offsetLeft, behavior: 'smooth' });
      updateButtons(index);
    }

    function updateButtons(index) {
      if (loop) {
        prevBtn.disabled = false;
        nextBtn.disabled = false;
        return;
      }
      var list = items();
      var step = perView();
      if (typeof index !== 'number') index = currentIndex();
      prevBtn.disabled = index <= 0;
      nextBtn.disabled = index >= list.length - step;
    }

    prevBtn.addEventListener('click', function () {
      goTo(currentIndex() - perView());
    });
    nextBtn.addEventListener('click', function () {
      goTo(currentIndex() + perView());
    });

    var scrollTimer;
    grid.addEventListener(
      'scroll',
      function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          updateButtons(currentIndex());
        }, 90);
      },
      { passive: true }
    );

    function syncVisibility() {
      if (mql.matches) {
        nav.hidden = false;
        updateButtons(currentIndex());
      } else {
        nav.hidden = true;
      }
    }

    if (mql.addEventListener) {
      mql.addEventListener('change', syncVisibility);
    } else if (mql.addListener) {
      mql.addListener(syncVisibility);
    }

    syncVisibility();
  }

  function bind(root) {
    if (root.dataset.atnGoBound === 'true') return;
    root.dataset.atnGoBound = 'true';
    bindAnalytics(root);
    bindSlider(root);
  }

  function init(scope) {
    (scope || document)
      .querySelectorAll('[data-atn-go-root]')
      .forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();